import ErrorPanel from "./ErrorPanel";

export default ErrorPanel;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ErrorPanel/index.tsx